export default __webpack_public_path__ + "static/media/bar-graph.515c3745.svg";